import { render, staticRenderFns } from "./MerchantBankDeposits.vue?vue&type=template&id=6cf3f75e"
import script from "./MerchantBankDeposits.vue?vue&type=script&lang=js"
export * from "./MerchantBankDeposits.vue?vue&type=script&lang=js"
import style0 from "./MerchantBankDeposits.vue?vue&type=style&index=0&id=6cf3f75e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports